import React from 'react';
import cs from 'classnames';

import css from './index.css';
import sharedCSS from '../../shared.css';

const HeadText = () => (
  <div className={cs(sharedCSS.wideStretchable, sharedCSS.unpadded)}>
    <div className={css.wrap}>
      <h1 className={css.header}>
        <strong>Thousands of available loads</strong>
      </h1>
      <div>
        Find the right load for any destination
      </div>
    </div>
  </div>
);

export default HeadText;



// WEBPACK FOOTER //
// ./src/components/Dashboard/HeadText/index.js